module.exports = __webpack_public_path__ + "8b2050b0df60cd4fd95588722af8c836.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentor/Nakagome@2x.png
// module id = 103
// module chunks = 0